<template>
  <div class="w-full self-end md:self-center">
    <div class="font-medium text-gray-600">{{sold}}/{{count}}</div>
    <div class="w-full bg-gray-300 h-1 rounded overflow-hidden">
      <div :class="`${color} h-1`" :style="`width: ${percentage}%`"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sold: {
      type: Number,
      default: 0
    },
    count: {
      type: Number,
      default: 0
    }
  },

  computed: {
    percentage() {
      return (this.sold / this.count) * 100;
    },
    color() {
      return this.percentage < 60
        ? "bg-green-500"
        : this.percentage < 90
        ? "bg-orange-500"
        : "bg-red-500";
    }
  }
};
</script>